var module = angular.module('octopusApp.shared');

module.directive('artifactListing', function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      artifacts: '='
    },
    templateUrl: 'areas/shared/views/artifact-listing.html',
    link: function (scope, element, attrs) {
    },
    controller: function($scope, octopusRepository) {
      $scope.formatDownload = function(artifact) {
        return octopusRepository.resolve(artifact.Links["Content"]);
      };
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/artifact_listing.js
// module id = 3314913265653184
// module chunks = 1